import _ from 'underscore';
import { usePilotsValue } from '@bingads-webui-campaign-react/basic-context-utils';
import { useMediaQuery } from '@bingads-webui-campaign-react/common-hooks';

// Define all pilots used in Smart Page over here.
export const PILOTS = {
  isESCMsanEnabled: 'isESCMsanEnabled',
  isSubscriptionSignupEnabled: 'IsSubscriptionSignupEnabled',
  isUnifiedProductSubscriptionEnabled: 'IsUnifiedProductSubscriptionEnabled',
  isSmartPageBusinessHourSectionEnabled: 'isSmartPageBusinessHourSectionEnabled',
  isSmartPageImageTextSuggestionEnabled: 'IsSmartPageImageTextSuggestionEnabled',
  isSmartPageM365StockImageEnabled: 'IsSmartPageM365StockImageEnabled',
  isSmartPageVideoSectionEnabled: 'isSmartPageVideoSectionEnabled',
  isSmartPageM365StockImageGalleryEnabled: 'isSmartPageM365StockImageGalleryEnabled',
  isSmartPageMapEnabled: 'isSmartPageMapEnabled',
  isSmartPageCustomizedUpdateEnabled: 'IsSmartPageCustomizedUpdateEnabled',
  isSmartPageM365PremiumFeatureEnabled: 'IsSmartPageM365PremiumFeatureEnabled',
  isSmartPageM365BannerEnabled: 'isSmartPageM365BannerEnabled',
  isSmartPageDarkModeEnabled: 'isSmartPageDarkModeEnabled',
  isM365PremiumUser: 'IsM365PremiumUser', // account level pilot
  isSmartPageProfessionalServicesEnabled: 'isSmartPageProfessionalServicesEnabled',
  isSmartPageBookAppointmentEnabled: 'isSmartPageBookAppointmentEnabled',
  isSmartPageEditorNavigationImprovementEnabled: 'isSmartPageEditorNavigationImprovementEnabled',
  isSmartPageTemplateSuggestionEnabled: 'isSmartPageTemplateSuggestionEnabled',
  isSmartPageImprovedReviewsEnabled: 'isSmartPageImprovedReviewsEnabled',
  isSmartPageSectionReorderingEnabled: 'isSmartPageSectionReorderingEnabled',
  isSmartPageEditorItemsReorderingEnabled: 'isSmartPageEditorItemsReorderingEnabled',
  isSmartPagePreviewItemsReorderingEnabled: 'isSmartPagePreviewItemsReorderingEnabled',
  isSmartPagePrivacyPolicyEnabled: 'isSmartPagePrivacyPolicyEnabled',
  isSmartPageCustomDomainEnabled: 'isSmartPageCustomDomainEnabled',
  isSmartPageCustomDomainPreflightEnabled: 'isSmartPageCustomDomainPreflightEnabled',
  isSmartPageCustomDomainPreflightPostSignupEnabled: 'isSmartPageCustomDomainPreflightPostSignupEnabled',
  isSmartPageRuntimePageLocalizationEnabled: 'isSmartPageRuntimePageLocalizationEnabled',
  isSmartPageRuntimePageWcpConsentEnabled: 'isSmartPageRuntimePageWcpConsentEnabled',
  isSmartPageAttributesToWSDMigrationEnabled: 'isSmartPageAttributesToWSDMigrationEnabled',
};

// Get pilot value from ServerContext
export const getPilotValue = (serverContext = {}, key) => {
  const cmuiPilotKey = key && key.replace(/^is/, 'Is');
  const ccuiPilotKey = key && key.replace(/^Is/, 'is');
  const uflPilotKey = key && key.replace(/^(is|Is)/, '').replace(/Enabled$/, ''); // ufl stands for Unified Feature Library

  const cmuiPilotValue = _.result(serverContext.Permissions, cmuiPilotKey, false);
  const ccuiPilotValue = _.result(serverContext.CCUIPilots, ccuiPilotKey, false);
  const uflPilotValue = _.result(serverContext.DynamicPermissions, uflPilotKey, false);

  return cmuiPilotValue || ccuiPilotValue || uflPilotValue;
};

// Below pilots are based on ServerContext instead of DataServiceContext

// We don't plan to support custom domain in Mobile
// This pilot is to control the basic feature and open the edit free website flow
export const useIsSmartPageCustomDomainPreflightEnabled = () => {
  const isPilotEnabled = usePilotsValue('isSmartPageCustomDomainPreflightEnabled');
  const { isMobile } = useMediaQuery();

  return isPilotEnabled && !isMobile;
};

export const useIsSmartPageCustomDomainPreflightPostSignupEnabled =
  () => usePilotsValue('isSmartPageCustomDomainPreflightPostSignupEnabled');

// This pilot is to control M365 domain option, the main custom domain logic
export const useIsSmartPageCustomDomainEnabled = (isSignUp) => {
  const isPilotEnabled = usePilotsValue('isSmartPageCustomDomainEnabled');
  const isSmartPageCustomDomainPreflightEnabled = useIsSmartPageCustomDomainPreflightEnabled();
  const isSmartPageCustomDomainPreflightPostSignupEnabled = useIsSmartPageCustomDomainPreflightPostSignupEnabled();

  return (isSignUp && isSmartPageCustomDomainPreflightEnabled && isPilotEnabled)
    || (!isSignUp && isSmartPageCustomDomainPreflightPostSignupEnabled && isPilotEnabled);
};
